export default "__VITE_ASSET__ySu7$sIj__"